import React from "react";
import "../App.css";

export const Cv = () => {
  document.title = "Lishal Bhari | CV";

  return (
    <div className="lis-container">
      <div className="cv-download">
        
      <a href={require("../Document/Lishal_cv.pdf")} download="Lishal CV"><img src="./Images/cv.png" alt="CV Icon" title="Download CV" height={50} width={50}/></a>
      </div>
      <div className="lis-cv_content">
        <div className="cv-left_side">
          <div className="cv-left_content">
            <div className="cv-left_bio">
              <div className="cv-left_bio_content">
                <img
                  src="./Images/Lishal Bhari.jpg"
                  alt="Lishal Bhari"
                  height={200}
                  width={280}
                  className="cv-left_bio_pic"
                />
                
                <strong><p style={{fontSize:'22px'}}>Lishal Bhari</p></strong>
                <strong><p style={{fontSize:'19px', marginTop:'-10px'}}>Web Developer</p></strong>
                <hr />
              </div>
              <div className="cv-left_bio_contact">
                <span>
                  
                  <b>Details</b> <br />
                </span>
                <div className="cv-left_bio_p">
                  <span>
                    <b>
                      <i>Currently: </i>
                    </b>
                    Hebbal, Bangalore
                  </span>
                  <span>
                    <b>
                      <i>Permanent: </i>
                    </b>
                    Kathmandu, Nepal
                  </span>
                  <span>
                    <b>
                      <i>Email: </i>
                    </b>
                    lbhari188@gmail.com
                  </span>
                  <span>
                    <b>
                      <i>Contact: </i>
                    </b>
                    9867232568 (Nepal)
                  </span>
                  <span>
                    <b>
                      <i>Contact: </i>
                    </b>
                    9148945180 (India)
                  </span>
                </div>
              </div>

              <div className="cv-left_bio_social">
                <span>
                  
                  <b>Social Account</b> <br />
                </span>
                <div className="cv-left_bio_p_social">
                  <span>
                    <b>
                      <i>Github:</i>
                    </b>
                    <a
                      style={{ textDecoration: "none", color: "black" }}
                      href="https://github.com/lishal"
                      target="__blank"
                    >
                      Github/Lishal
                    </a>
                  </span>
                  <span>
                    <b>
                      <i>Facebook:</i>
                    </b>
                    <a
                      style={{ textDecoration: "none", color: "black" }}
                      href="https://www.facebook.com/lishalbhari"
                      target="__blank"
                    >
                      facebook/lishalbhari
                    </a>
                  </span>
                </div>
              </div>

              <div className="cv-left_bio_language">
                <span>
                  
                  <b>Language Known</b> <br />
                </span>
                <div className="cv-left_bio_p_language">
                  <span>
                    <b>
                      <i>English</i>
                    </b>
                  </span>
                  <span>
                    <b>
                      <i>Nepali</i>
                    </b>
                  </span>
                </div>
              </div>

              <div className="cv-left_bio_hobbies">
                <span>
                  
                  <b>Hobbies</b> <br />
                </span>
                <div className="cv-left_bio_p_hobbies">
                  <span>
                    <b>
                      <i>Coding</i>
                    </b>
                  </span>
                  <span>
                    <b>
                      <i>Gaming</i>
                    </b>
                  </span>
                  <span>
                    <b>
                      <i>Travelling</i>
                    </b>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="cv-right_side">
          <div className="cv-right_content">
            <div className="cv-right_about">
              <h2>About</h2>
              <p>
                My career objective is to succeed in an environment of growth
                and excellence and earn a job which provides me job satisfaction
                and self-development and help achieve personal as well as
                organizational goals.
              </p>
            </div>
            <div className="cv-right_summary" style={{ marginTop: "20px" }}>
              <h2>Summary</h2>
              <ul>
                <li>
                  Currently working in LG Soft India, Bangalore as a Test
                  Engineer
                </li>
                <li>
                  Worked in Empathy IT Club, Kathmandu, Nepal as an Intern for
                  Web Developer position and got chance to work on real time
                  application i.e Tour and Travel web application
                </li>
                <li>
                  Recently completed MCA(Masters In Computer Application) from
                  NMIT College, Yelahanka, Bangalore, India.
                </li>
                <li>
                  Designed and Developed a web application using php as a
                  language and Laravel as a framework following MVC and created
                  Cinema Management System, Restaurants Management System,
                  Steganography and many minor projects.
                </li>
                <li>
                  In React Js, I have created a project as Simple Counter
                  System, TextUtils, Fetching API and manipulating those data
                  also own Portfolio.
                </li>
              </ul>
            </div>
            <div className="cv-right_ts">
              <h2 style={{margin:'5px 0px'}}>Technical Skills</h2>
              <p>
                <strong>Technology:</strong>HTML, CSS, JavaScript, PHP, Python, SQL, MongoDb, Express Js
              </p>
              <p style={{marginLeft:'-18px'}}>
              <strong>Frameworks:</strong> Laravel, React Js, Bootstrap
              </p>
            </div>
            <div className="cv-right_edu">
              <h2 style={{ marginTop: "20px" }}>Eduation</h2>
              <ul>
                <li>
                  MCA from Nitte Meenakshi Institue of Technology with an average of 8.7 CGPA
                </li>
                <li>
                  BSc(Hons) in Computing from Islington College affiliated to London Metropolitan University 
                  with average of 68.06%
                </li>
                <li>
                  In 2017, completed my Senior Secondary with 61.05% from United Academy, Lalitpur, Nepal
                </li>
                <li>
                  In 2015, completed my Class 10 from New Horizon Institue, Butwal, Nepal with an average of 64.8%
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
